import store from '../store';
export default {
  inheritAttrs: true,
  props: ['value', 'options'],
  computed: {
    fieldValue: {
      get() {
        return this.value;
      },
      set(e) {
        this.$emit('input', e);
      },
    },
    rules() {
      let manualRule = this.$attrs.rule;
      let customRule =
        this.options &&
        this.options
          .filter((x) => x.ref == this.$attrs.name)
          .map((y) => y.rule)[0];

      if (store.getters['orders/isQuote']) {
        return customRule ? customRule : '';
      } else {
        return manualRule ? manualRule : customRule;
      }
    },
    hidden() {
      let manualHidden = this.$attrs.hidden;
      let customHidden =
        this.options &&
        this.options
          .filter((x) => x.ref == this.$attrs.name)
          .map((y) => y.option) == 'hidden';

      return manualHidden ? manualHidden : customHidden;
    },
    readonly() {
      let manualReadonly = this.$attrs.readonly;
      let customReadonly =
        this.options &&
        this.options
          .filter((x) => x.ref == this.$attrs.name)
          .map((y) => y.option) == 'disabled';

      return manualReadonly ? manualReadonly : customReadonly;
    },
  },
  methods: {
    emit(val) {
      this.$emit('input', val);
    },
  },
};
